var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBittenoli(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 507.6 672.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    x1: 493.87,
    y1: 228.46,
    x2: -7.15,
    y2: 1007.23,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1025.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e9eab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef2f3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.82,375.56q-32.82-43.1-93.78-61c31.5-15.62,55-36,70.62-61.46s23.39-52.46,23.39-81.15c0-30.83-8.76-60.46-26.35-88.67s-41.88-49.22-72.95-62.9Q332.09,1.31,261.49.1c-3.09,0-6.19-.1-9.34-.1H0V672.22H256.35c1.71,0,3.43,0,5.19-.05q60.75-.42,103.26-11.24,44.24-11.22,73.56-33.21t49.32-62.56q19.88-40.6,19.92-87.77Q507.6,418.71,474.82,375.56ZM402.1,534c-8.81,16.4-20.15,28.83-33.87,37.36S337.35,586,316.86,589.74Q299.49,593,256.35,593H89V79.43H223.28q72.41,0,102.21,9.34c19.91,6.29,35.16,17.91,45.93,34.88s16,36.59,16,58.94q0,35.24-17.2,58.7c-11.49,15.53-28.5,26.73-51.13,33.45q-25.67,7.86-84.81,7.81l-21.11-.28-79.34,79.38,110.55.29q64.11,0,98.34,11.24t53.42,39q19.23,27.72,19.25,65.37C415.45,498.78,411,517.7,402.1,534Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBittenoli);
export default __webpack_public_path__ + "static/media/Bittenoli.e52ec6be723ee9b865be004147aabb13.svg";
export { ForwardRef as ReactComponent };